var PasswordResetModule = (function () {
    function PasswordResetModule() {
    }
    return PasswordResetModule;
}());
export { PasswordResetModule };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/password-reset/password-reset.module.ts.pre-build-optimizer.js